module.exports = __webpack_public_path__ + "img/Z86_15.508e6c03.jpg";